import { Route, Routes } from "react-router-dom";
import { RequirePermission } from "@comps/components";
import IndexRoles from "./roles/IndexRoles";
import IndexUsers from "./users/IndexUsers";

/** Same keys the sidebar filters on — see userCase/routes.jsx. */
const UserManagementRoutes = () => {
  return (
    <Routes>
      <Route path="/roles" element={ <RequirePermission permission="roles_index"><IndexRoles /></RequirePermission> } />
      <Route path="/users" element={ <RequirePermission permission="users_index"><IndexUsers /></RequirePermission> } />
    </Routes>
  )

}

export default UserManagementRoutes;
